import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Clock, Calendar, AlertCircle, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import { GrasrotandelenBanner } from '../components/GrasrotandelenBanner';
import { FieldMap } from '../components/FieldMap';
import { SEO } from '../components/SEO';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

const getschedule = () => [
  {
    day: t('pg.Treningstider.9ef555'),
    sessions: [
      { team: 'J7 & J8', time: '16:30 – 17:30', field: '11er A' },
      { team: 'G8', time: '17:00 – 18:30', field: '7er A' },
      { team: 'G9', time: '17:00 – 18:30', field: '7er B' },
      { team: 'J12', time: '17:00 – 18:30', field: '11er B' },
      { team: 'G11', time: '17:00 – 18:30', field: '11er A' },
      { team: 'G13', time: '18:30 – 20:00', field: '11er A' },
      { team: 'G14', time: '18:30 – 20:00', field: '11er B' },
    ],
  },
  {
    day: t('pg.Treningstider.4b63ac'),
    sessions: [
      { team: 'G6 & G7', time: '16:30 – 18:00', field: t('pg.Treningstider.321527') },
      { team: 'G10', time: '18:00 – 19:30', field: t('pg.Treningstider.321527') },
      { team: 'G13', time: '18:00 – 19:30', field: t('pg.Treningstider.8fe719') },
      { team: 'G19', time: '19:30 – 21:00', field: '11er A' },
      { team: t('pg.Treningstider.a010e1'), time: '19:30 – 21:00', field: '11er B' },
    ],
  },
  {
    day: t('pg.Treningstider.e366c4'),
    sessions: [
      { team: 'G14', time: '18:30 – 20:00', field: t('pg.Treningstider.321527') },
      { team: t('pg.Treningstider.70ef2c'), time: '19:30 – 21:00', field: t('pg.Treningstider.8fe719') },
    ],
  },
  {
    day: t('pg.Treningstider.01ef99'),
    sessions: [
      { team: 'J12', time: '16:30 – 18:00', field: t('pg.Treningstider.8fe719') },
      { team: 'G11', time: '17:00 – 18:30', field: '11er A' },
      { team: 'G13', time: '17:00 – 18:30', field: '11er B' },
      { team: 'G19', time: '18:30 – 20:00', field: '11er A' },
      { team: t('pg.Treningstider.a010e1'), time: '18:30 – 20:00', field: '11er B' },
      { team: t('pg.Treningstider.95125c'), time: '19:30 – 21:00', field: t('pg.Treningstider.8fe719') },
    ],
  },
  {
    day: t('pg.Treningstider.544783'),
    sessions: [
      { team: t('pg.Treningstider.d5697f'), time: '16:00 – 18:30', field: t('pg.Treningstider.edbc82') },
    ],
  },
  {
    day: t('pg.Treningstider.9f4616'),
    sessions: [],
  },
  {
    day: t('pg.Treningstider.128be2'),
    sessions: [
      { team: t('pg.Treningstider.5b60c4'), time: '11:00 – 13:00', field: t('pg.Treningstider.321527') },
      { team: 'G12', time: '15:30 – 17:00', field: t('pg.Treningstider.8fe719') },
      { team: t('pg.Treningstider.70ef2c'), time: '19:30 – 21:00', field: t('pg.Treningstider.8fe719') },
    ],
  },
];

export const Treningstider = () => {
  useTranslation();
  return (
    <div data-testid="treningstider-page">
      <SEO
        title={t('pg.Treningstider.dee457')}
        description={t('pg.Treningstider.87c41f')}
      />

      {/* Hero */}
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <Link
            to="/soccer"
            data-testid="back-to-soccer-btn"
            className="inline-flex items-center gap-2 text-slate-300 hover:text-green-400 transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('pg.Treningstider.2ac064')}
          </Link>

          <div className="max-w-3xl">
            <p className="text-green-400 font-medium uppercase tracking-widest mb-4 flex items-center gap-2">
              <Calendar className="w-4 h-4" /> {t('pg.Treningstider.8117e9')}
            </p>
            <h1 className="text-5xl sm:text-6xl font-bold tracking-tighter text-white mb-6">
              {t('pg.Treningstider.345780')} <span className="text-green-400">{t('pg.Treningstider.4bcd8c')}</span>
            </h1>
            <p className="text-xl text-slate-300 leading-relaxed">
              {t('pg.Treningstider.a6aa67')}
            </p>
          </div>
        </div>
      </section>

      {/* Preliminary Notice */}
      <section className="px-4 sm:px-6 lg:px-8 -mt-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="bg-amber-50 dark:bg-amber-900/20 border-2 border-amber-300 dark:border-amber-700/50 rounded-2xl p-5 sm:p-6 shadow-lg flex items-start gap-4">
            <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
              <AlertCircle className="w-5 h-5 text-amber-600 dark:text-amber-400" aria-hidden="true" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-slate-900 dark:text-white mb-2">
                {t('pg.Treningstider.269820')}
              </h2>
              <p className="text-slate-700 dark:text-slate-200 leading-relaxed">
                {t('pg.Treningstider.3a514f')} <strong>{t('pg.Treningstider.0837c9')}</strong>{t('pg.Treningstider.3bea49')} <strong>{t('pg.Treningstider.27391e')}</strong> {t('pg.Treningstider.597cd6')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Field Map */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-6">
            <p className="text-green-500 font-medium uppercase tracking-widest mb-2 flex items-center justify-center gap-2">
              <MapPin className="w-4 h-4" /> {t('pg.Treningstider.56c5c7')}
            </p>
            <h2 className="text-3xl font-bold tracking-tighter text-slate-900 dark:text-white">
              {t('pg.Treningstider.75bd50')}
            </h2>
            <p className="text-slate-500 dark:text-slate-400 mt-2 text-sm">
              {t('pg.Treningstider.53eada')} <strong>A</strong> og <strong>B</strong>{t('pg.Treningstider.8f157a')} <strong>7er-bane</strong>.
            </p>
          </div>
          <FieldMap />
        </div>
      </section>

      {/* Schedule by Day */}
      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="grid gap-6">
            {getschedule().map((dayBlock) => (
              <div
                key={dayBlock.day}
                className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden"
              >
                <div className="bg-gradient-to-r from-green-500 to-green-600 px-6 py-4 flex items-center gap-3">
                  <Calendar className="w-5 h-5 text-white" aria-hidden="true" />
                  <h3 className="text-xl font-bold text-white tracking-tight">{dayBlock.day}</h3>
                  <span className="ml-auto text-white/80 text-sm font-medium">
                    {dayBlock.sessions.length}{' '}
                    {dayBlock.sessions.length === 1 ? t('pg.Treningstider.fc912f') : t('pg.Treningstider.ec4cd1')}
                  </span>
                </div>

                {dayBlock.sessions.length === 0 ? (
                  <div className="p-6 text-center text-slate-500 dark:text-slate-400 italic">
                    {t('pg.Treningstider.4f1fd1')}
                  </div>
                ) : (
                  <div className="divide-y divide-slate-200 dark:divide-slate-700">
                    {dayBlock.sessions.map((s, i) => (
                      <div
                        key={i}
                        className="px-6 py-4 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:items-center hover:bg-slate-50 dark:hover:bg-slate-900/50 transition-colors"
                      >
                        <div className="font-bold text-slate-900 dark:text-white text-lg">
                          {s.team}
                        </div>
                        <div className="flex items-center gap-2 text-slate-700 dark:text-slate-300">
                          <Clock className="w-4 h-4 text-green-500" aria-hidden="true" />
                          <span className="font-medium">{s.time}</span>
                        </div>
                        <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                          <MapPin className="w-4 h-4 text-slate-400" aria-hidden="true" />
                          <span className="text-sm">{s.field}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-slate-50 dark:bg-slate-900">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-slate-600 dark:text-slate-300 mb-6">
            {t('pg.Treningstider.363fb3')}
          </p>
          <Link to="/soccer">
            <Button className="bg-green-500 text-white font-bold uppercase tracking-wider px-8 py-6 hover:bg-green-600 shadow-lg">
              {t('pg.Treningstider.0eefeb')}
            </Button>
          </Link>
        </div>
      </section>

      <GrasrotandelenBanner />
    </div>
  );
};

export default Treningstider;
